import React, {useRef, useState} from "react";
import {ManualBox2} from "../manualsBox/golf-products-manualsBox";

export const tabList = [
    {idx: 1, title : 'Features'},
    {idx: 2, title : 'Description'},
    {idx: 3, title : 'Specifications'},
    {idx: 4, title : 'Manuals'},
]
export const LX4K = () => {
    const [tabIndex, setTabIndex] = useState<number>(1)
    const scrollRef = [
        useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null), useRef<any>(null)
    ];

    return (
        <>
            <div className="product_view upl2000">
                <div className="bgBox" style={{backgroundImage: "url('/assets/images/product/lx4k/banner.jpg')"}}>
                    <section className="section_0">
                        <div className="image-box">
                            <div className="text-box">
                                <p className="text-01">LX4K</p>
                                <p className="text-02">Unmatched Clarity<br/>
                                    on Screen
                                </p>
                                <ul style={{margin: '25px 0 0'}}>
                                    <li>
                                        <img src="/assets/images/product/lx4k/lx4k-image-01.png" alt=""/>
                                    </li>
                                    <li>
                                        <img src="/assets/images/product/lx4k/lx4k-image-02.png" alt=""/>
                                    </li>
                                    <li>
                                        <img src="/assets/images/product/lx4k/lx4k-image-03.png" alt=""/>
                                    </li>
                                    <li>
                                        <img src="/assets/images/product/lx4k/lx4k-image-04.png" alt=""/>
                                    </li>
                                    <li>
                                        <img src="/assets/images/product/lx4k/lx4k-image-05.png" alt=""/>
                                    </li>
                                    <li>
                                        <img src="/assets/images/product/lx4k/lx4k-image-06.png" alt=""/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </section>
                    <div className="scrollDownBox">
                        <div>
                            <span></span>
                        </div>
                        <span>SCROLL</span>
                    </div>
                </div>

                <div className="tabWrap tabBtnWrapBattery">
                    <div className="tabBtnWrap">
                        <div className="tabBtnBox">
                            {tabList.map((list:{idx:number,title:string})=>(
                                <button className={tabIndex===list?.idx?'active':''} onClick={()=>setTabIndex(list?.idx)}>
                                    {list?.title}
                                </button>
                            ))}
                        </div>
                    </div>


                    <div className="tabContentBox">
                        {tabIndex === 1 && <div className={`features active`}>
                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02" style={{display: 'flex', gap: '10px', alignItems: 'center'}}>True 4K <img src="/assets/images/product/lx4k/lx4k-image-01-01.png" alt=""/></p>
                                            <p className="text-03">
                                                Experience native 4K resolution powered by<br/>
                                                the STARVIS 2 IMX 678 sensor,<br/>
                                                delivering superior image quality without upscaling.<br/>
                                            </p>
                                            <p className="text-03">Feel the difference in clarity.</p>
                                            <p className="text-04">
                                                <img src="/assets/images/product/lx4k/lx4k-image-01-02.png" alt=""/>&nbsp;&nbsp;
                                                <img src="/assets/images/product/lx4k/lx4k-image-01-03.png" alt=""/>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-01.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">Ultra-High Sensitivity<br/>
                                                Image Sensor
                                            </p>
                                            <p className="text-03">
                                                <img src="/assets/images/product/lx4k/lx4k-image-01-04.png" alt=""/><br/>
                                            </p>
                                            <p className="text-04">
                                                Minimizes light bleed for exceptional<br/>
                                                image quality, day and night.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-02.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">Auto Super Night Vision 2.0</p>
                                            <p className="text-03">
                                                The synergy of STARVIS 2 and advanced image<br/>
                                                processing ensures crystal-clear footage, even at night.
                                            </p>
                                            <p className="text-03">
                                                FineVu’s proprietary image tuning enhances clarity<br/>
                                                across all conditions—from daytime drives to<br/>
                                                nighttime parking.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-03.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">170° Panoramic View</p>
                                            <p className="text-03">
                                                <em>FineVu’s premium 7‑layer glass lens gives you a true 170° field of<br/>
                                                    view with edge‑to‑edge clarity.</em>
                                            </p>
                                            <p className="text-03">
                                                Unlike plastic lenses that warp and blur in extreme heat,<br/>
                                                our high‑grade glass optics stay sharp—even in 140°F+ cabins.
                                            </p>
                                            <p className="text-03">
                                                See more of the road, from multi‑lane highways to crowded city streets,<br/>
                                                day or night.<br/>
                                                FineVu helps you capture every detail when it matters most.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-04.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">Why a 3.5" LCD is Better</p>
                                            <ul style={{listStyle: 'disc inside'}}>
                                                <li className="text-03"><em>Larger screen</em> for better visibility</li>
                                                <li className="text-03"><em>Higher resolution</em> for sharper images</li>
                                                <li className="text-03"><em>Clearer text and icons</em></li>
                                                <li className="text-03"><em>More user-friendly interface</em></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-05.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_1">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-01">Support Across Borders</p>
                                            <p className="text-02">Speed & Red Light Camera</p>
                                            <p className="text-03">Avoid accidents and speeding tickets with ease.<br/>
                                                Powered by high-precision GPS, get smart, real-time alerts for<br/>
                                                speed and red-light cameras  even when crossing<br/>
                                                the US–Canada border.</p>
                                            <p className="text-04">Free monthly updates for speed camera data across 28 countries.</p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-06.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">ADAS <span style={{fontWeight: 'normal', fontSize: '24px'}}>(Advanced Driver Assistance Systems)</span><br/>
                                                Keeping You Safe On The Road</p>

                                            <p className="text-04">
                                                Smart assistance that monitors the road in real-time.<br/>
                                                By detecting hazards in advance and providing instant alerts,<br/>
                                                FineVu helps ensure a safer driving experience.

                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-07.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_11">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">Faster 5GHz Wi-Fi &<br/>
                                                OTA Firmware Update
                                            </p>
                                            <p className="text-03">
                                                Download videos, firmware updates instantly<br/>
                                                with high-speed 5GHz Wi-Fi.
                                            </p>
                                            <p>
                                                <img src="/assets/images/product/lx4k/lx4k-image-08.jpg" alt="" style={{width: '100%'}}/>
                                            </p>
                                            <p className="text-04">＊ Instant One-Tap BT: No complex pairing required. Connect with a single tap via Bluetooth.<br/>
                                                ＊ PC Player Supported: Download "FineVu PC Player 4K" from the official FineVu website.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-09.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">Smart Screen Saver</p>
                                            <p className="text-04">
                                                When active, the display switches to a minimalist<br/>
                                                dashboard view to minimize driver distraction.<br/>
                                                Check speed, time, and system status at a glance.<br/>
                                                The high-contrast layout ensures easy readability, day or night.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-10.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_11">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">Hybrid Loop Recording</p>
                                            <p className="text-03">When the memory card becomes full,<br/>
                                                older footage is automatically overwritten<br/>
                                                to ensure continuous recording.
                                            </p>
                                            <p className="text-03">Additionally, advanced wear leveling* technology maximizes<br/>
                                                the lifespan of your memory card.</p>

                                            <p className="text-04">＊ Wear Leveling : It has a feature that ensures that data is recorded evenly,<br/>
                                                &nbsp;&nbsp;&nbsp;&nbsp;preventing device errors and data loss by preventing certain areas from being<br/>
                                                &nbsp;&nbsp;&nbsp;&nbsp;overused.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-11.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>


                            <section className="section_11">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">24/7 Power Saving Parking Mode</p>
                                            <p className="text-03">
                                                <em>Up to 4 Months of Parking Protection</em>
                                            </p>
                                            <p className="text-03">
                                                Stay protected even during long trips, airport parking,<br/>
                                                or extended storage.
                                            </p>
                                            <p>
                                                <img src="/assets/images/product/lx4k/lx4k-image-12.jpg" alt="" style={{width: '100%'}}/>
                                            </p>
                                            <p className="text-04">＊ This feature only works in parking mode. To use parking mode,<br/>
                                                &nbsp;&nbsp;you must install a hardwire kit or an external battery pack (each sold separately)
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-13.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_11">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-03">
                                                <em>Records for Over a Week During Long-Term Parking</em>
                                            </p>
                                            <p className="text-02">Smart Time-Lapse</p>
                                            <p className="text-03">
                                                When Smart Time-Lapse is active, driving footage is<br/>
                                                5x more efficient than standard recording. In Parking Mode,<br/>
                                                video is captured at 2 fps, compressing file sizes by up to 15x<br/>
                                                compared to regular parking video.
                                            </p>
                                            <p className="text-03">
                                                If an impact is detected, a 20-second event video is<br/>
                                                automatically saved, capturing 5 seconds before and<br/>
                                                15 seconds after the incident.
                                            </p>
                                            <p className="text-04">＊ This feature only works in parking mode. To use parking mode,<br/>
                                                &nbsp;&nbsp;you must install a hardwire kit or an external battery pack (each sold separately)
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-14.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_11">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">Smart AI Overheat Protection</p>
                                            <p className="text-03">
                                                During Motion or Smart Time-lapse recording,<br/>
                                                AI-driven monitoring automatically adjusts<br/>
                                                recording modes based on thermal conditions.
                                            </p>
                                            <p className="text-03">
                                                If overheating is detected, it activates a low-power mode.<br/>
                                                When the temperature stabilizes, it automatically resumes<br/>
                                                standard recording to ensure uninterrupted protection.
                                            </p>
                                            <p className="text-04">＊ This feature only works in parking mode. To use parking mode,<br/>
                                                &nbsp;&nbsp;you must install a hardwire kit or an external battery pack (each sold separately)
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-15.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_11">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">No More Dead Battery Worries</p>
                                            <p className="text-03">
                                                The dash cam automatically powers off<br/>
                                                if your vehicle's battery drops below a preset voltage level,<br/>
                                                helping prevent battery drain.
                                            </p>
                                            <p className="text-03">
                                                You can also adjust the voltage cutoff setting to<br/>
                                                suit your vehicle's needs.
                                            </p>
                                            <p className="text-04">＊ When Winter Setting Mode is enabled, the dash cam shuts off 0.2V above<br/>
                                                &nbsp;&nbsp;the preset low-voltage cutoff.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-16.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-02">High-Durability Supercapacitor</p>
                                            <p className="text-03">
                                                Engineered with a high-durability Supercapacitor for<br/>
                                                superior heat resistance compared to lithium batteries.<br/>
                                                It ensures stable operation and saves footage safely<br/>
                                                during sudden power loss or impacts—protecting your data<br/>
                                                when it matters most.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-17.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-01">Easy Touch Screen</p>
                                            <p className="text-02">Simple and Easy Touch<br/>
                                                Like A Smartphone
                                            </p>
                                            <p className="text-03">
                                                Enjoy a smooth, intuitive UI on a high-resolution IPS display,<br/>
                                                designed to feel as familiar as your smartphone.<br/>
                                                A larger screen lets you see more at a glance,<br/>
                                                minimizing the need for excessive scrolling.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-18.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_6">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-01">Zero Missed Footage</p>
                                            <p className="text-02">Industrial-Grade SD Card</p>
                                            <p className="text-03">
                                                Engineered for harsh environments,<br/>
                                                delivering superior durability, lifespan,<br/>
                                                and data protection beyond standard SD cards.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-19.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>

                            <section className="section_11">
                                <div className="half">
                                    <div className="text-area">
                                        <div>
                                            <p className="text-01">Easy Setup For Anyone</p>
                                            <p className="text-02">Plug & Play 12V Power &<br/>
                                                Simple DIY Installation
                                            </p>
                                            <ul style={{listStyle: 'disc', paddingLeft: '25px'}}>
                                                <li className="text-03">Instant Plug & Play: Connect to your 12V socket for immediate<br/> driving recording—no complex wiring needed.</li>
                                                <li className="text-03">10-Minute DIY Setup: Install it yourself easily without a professional<br/> technician or extra tools.</li>
                                                <li className="text-03">Instant LCD Screen View: Powers on automatically with a live view<br/> as soon as you start your car.</li>
                                                <li className="text-03">Clean Cable Management: Easily tuck the slim cable along<br/> your vehicle's headliner for a neat finish.</li>
                                            </ul>
                                            <p className="text-04">＊ For 24/7 Parking Mode, the FineVu Hardwiring Cable is required and sold separately.</p>
                                        </div>
                                    </div>
                                    <div className="image-area">
                                        <img src="/assets/images/product/lx4k/lx4k-image-20.jpg" alt=""/>
                                    </div>
                                </div>
                            </section>
                        </div>}
                        {tabIndex === 2 && <div className={`whatsInTheBox active`}>
                            <section>
                                <div className="imgBox">
                                    <h3>Product Description</h3>
                                    <img src="/assets/images/product/lx4k/lx4k-desc-01.jpg" alt="Product Description"/>
                                </div>
                                <div className="imgBox" style={{marginBottom: '30px'}}>
                                    <h3>WHAT’S IN THE BOX</h3>
                                    <img src="/assets/images/product/lx4k/lx4k-desc-02.jpg" alt="What's In The Box"/>
                                </div>
                                <ul>
                                    <li>※ To improve the performance of the product, its components may change without prior notice.</li>
                                    <li>※ The warranty period of the Micro SD card is 6 months.</li>
                                </ul>
                                <div className="imgBox" style={{marginTop: '30px'}}>
                                    <h3>Hardwire Kit for Easy DIY Installation</h3>
                                    <img src="/assets/images/product/lx4k/lx4k-desc-03.jpg" alt="Hardwire Kit for Easy DIY Installation"/>
                                </div>
                            </section>
                        </div>}
                        {tabIndex === 3 && <div className={`specifications active`}>
                            <div className="tableWrap">
                                <table>
                                    <thead>
                                    <tr>
                                        <th>&nbsp;</th>
                                        <th>FineVu LX4K</th>
                                        <th>Remark</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <th rowSpan={2}>Image Sensor</th>
                                        <td>
                                            Front: 8M pixels CMOS Image Sensor (1/1.8")
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            Rear: 2M pixels CMOS Image Sensor (1/2.9")
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Resolution</th>
                                        <td>3840*2160(4K UHD) / 1920*1080P(Full HD)</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Frames Per Second</th>
                                        <td>30fps</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Viewing angle</th>
                                        <td>
                                            Front: 170°<br/>
                                            Rear: 124.4°
                                        </td>
                                        <td>Diagonal</td>
                                    </tr>
                                    <tr>
                                        <th>Recording Mode</th>
                                        <td>
                                            Driving Recording (Standard, Shock Detection, Smart Time Lapse),<br/>
                                            Manual Recording, Parking Recording (Motion Detection, Shock Detection,<br/>
                                            Smart Time Lapse, Power Saving Parking)
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Display</th>
                                        <td>3.5” IPS LCD (800 x 480) with Touch</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Acceleration Sensor</th>
                                        <td>3-axis acceleration Sensor</td>
                                        <td>+2g / -2g</td>
                                    </tr>
                                    <tr>
                                        <th>GPS</th>
                                        <td>External</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Wi-Fi</th>
                                        <td>Built-In(dongle)</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Storage Capacity</th>
                                        <td>FineVu Micro SD Card (32GB / 64GB / 128GB / 256GB)</td>
                                        <td>Class 10 or above, SDXC support</td>
                                    </tr>
                                    <tr>
                                        <th>Battery</th>
                                        <td>Super capacitor</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>MIC</th>
                                        <td>Built-In</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Speaker</th>
                                        <td>Built-In</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Interface</th>
                                        <td>
                                            Power port, Rear camera port, external GPS port, Micro SD card slot<br/>
                                            BT/Dual-band Wi-Fi(2.4GHz/5GHz) Dongle, Power switch
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Security LED</th>
                                        <td>Front : White / Rear : Blue</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Input Power</th>
                                        <td>DC 12V-24V</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Power Consumption</th>
                                        <td>
                                            Parking Mode : 4.4W<br/>
                                            Power Saving Parking Mode : 0.048W
                                        </td>
                                        <td>2CH, LCD OFF, GPS OFF Actual power consumption may vary depending on the recording setting and usage environment.</td>
                                    </tr>
                                    <tr>
                                        <th>High Temperature Cut-Off</th>
                                        <td>AI Heat Monitoring</td>
                                        <td>During parking mode</td>
                                    </tr>
                                    <tr>
                                        <th>Low Voltage Cut-Off</th>
                                        <td>Supported</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Temperature</th>
                                        <td>
                                            Operation : -10℃ ~ 60℃ (14℉ ~ 140℉)<br/>
                                            Storage : -20℃ ~ 70℃ (-4℉ ~158℉)
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Size (WxDxH)</th>
                                        <td>
                                            Front : 3.98x2.55x1.29 in (101.2x64.7x32.7 mm)<br/>
                                            Rear : 1.85x1.18x1.44 in (46.9x29.9x36.5 mm)
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Weight</th>
                                        <td>
                                            Front : 152g (5.36oz)<br/>
                                            Rear : 21g (0.74oz)
                                        </td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Language Supported</th>
                                        <td>English</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <th>Mobile Application</th>
                                        <td>FineVu CLOUD & Wi-Fi App</td>
                                        <td>Android, iOS</td>
                                    </tr>
                                    <tr>
                                        <th>PC Viewer</th>
                                        <td>FineVu Player 2.0</td>
                                        <td>Windows, MAC</td>
                                    </tr>
                                    <tr>
                                        <th>Features</th>
                                        <td>
                                            ADAS PLUS (FVMA / LDWS), PIP, User Text Overlay,<br/>
                                            Hybrid Loop Recording Smart Time Lapse, Format Free, Secret Mode,<br/>
                                            Speed Camera Alert, Safety Screen, High-temperature cut-off,<br/>
                                            Power Saving Parking Mode, Auto Super Night Vision, On-time notification,<br/>
                                            Battery discharge prevention, Warning for long distance driving,<br/>
                                            1-channel recording support
                                        </td>
                                        <td>Vehicle speed, ADAS, and Speed Camera Alert work only when the GPS is receiving.</td>
                                    </tr>
                                    <tr>
                                        <th>Certification</th>
                                        <td className="imgArea">
                                            <div>
                                                <img src="/assets/images/table_certification.png" alt="Certification"/>
                                            </div>
                                        </td>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                        {tabIndex === 4 && <ManualBox2/>}
                    </div>
                </div>
            </div>
        </>
    )
}
